<ng-container *ngIf="nextBill">
    <h2 class="title margin-top mt40" [ngClass]="{'dm-sans-medium': !isAcmic, 'col-363636-imp': isAcmic}">
        {{ 'NEXT_BILL' | translate }}
    </h2>

    <div class="date-amount margin-right mr16 margin-top mt16" [ngClass]="{'grey-color':!isAcmic}">
        <img class="margin-right mr4" src="assets/img/images/icon-calendar.svg" *ngIf="!isAcmic" alt="calendar icon" />
        {{ 'NEXT_AMOUNT_DUE' | translate }} :
        <span class="date-amt-inner">
            <strong [ngClass]="{'col-2d373d':!isAcmic,'ml8-imp' : isAcmic}">{{ nextBill?.minAmountDue | currency }} </strong>
            <!-- <br class="d-block d-md-none" /> -->
            <strong [ngClass]="{'col-2d373d':!isAcmic}">{{ ' on ' }} {{ nextBill?.dateDue | customDateFormat }}
            </strong>
        </span>
    </div>
</ng-container>
<ng-container *ngIf="transactions">
    <h2 class="title margin-top mt32 padding-top pt16" [ngClass]="{'dm-sans-medium': !isAcmic}">
        {{ 'TRANSACTION_HISTORY' | translate }}
    </h2>
    <div class="margin-top mt16 select-class margin-bottom mb16 trans-sub-label" id="select-class"
        [ngClass]="{'col-656565-imp' : isAcmic}">
        {{ 'Select a transaction date range' | translate }}
    </div>
    <ng-container *ngIf="isAcmic; else maTransactionFilter">
        <form name="transactionFormGroup" [formGroup]="transactionFormGroup" (ngSubmit)="filterTransactions()">
            <div class="margin-bottom mb8 margin-top mt8"
                [ngClass]="{ 'acmic-date-container': isAcmic, 'display-flex align-items-center': isAcmic, 'ios-device': isIOS }">
                <div class="date-fields-row">
                    <div class="input-field mapfre filter-input transaction-date-col start-date date-field-flex"
                        [ngClass]="{ 'acmic-date-flex': isAcmic }">
                        <div class="date-label">Start date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('fromDate')?.value">
                            <input id="from-date" [ngClass]="{ 'border-required date-input': isAcmic }" name="from-date"
                                type="date" placeholder="mm/dd/yyyy" min="2000-01-01" max="2100-12-31"
                                [formControlName]="'fromDate'" (blur)="compareDates()" (keyup)="compareDates()"
                                (change)="compareDates()" mdbInput #fromDate />
                            <img src="assets/img/images/icon-calendar-acmic.svg" alt="calendar icon"
                                class="calendar-icon-inside" (click)="openDatePicker('from')" />
                        </div>
                    </div>

                    <div class="input-field mapfre filter-input transaction-date-col end-date date-field-flex"
                        [ngClass]="{ 'acmic-date-flex': isAcmic }">
                        <div class="date-label">End date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('toDate')?.value">
                            <input id="to-date" [ngClass]="{ 'border-required date-input': isAcmic }" name="to-date"
                                type="date" placeholder="mm/dd/yyyy" min="2000-01-01" max="2100-12-31"
                                [formControlName]="'toDate'" (blur)="compareDates()" (keyup)="compareDates()"
                                (change)="compareDates()" mdbInput #toDate />
                            <img src="assets/img/images/icon-calendar-acmic.svg" alt="calendar icon"
                                class="calendar-icon-inside" (click)="openDatePicker('to')" />
                        </div>
                    </div>
                </div>

                <div class="filter-button-row">
                    <div class="transaction-date-col submit-date">
                        <mapfre-button [additionalClasses]="' small transaction-filter-b-radius trans-filter-btn'"
                            [translateValue]="'FILTER' | translate"
                            [disabledValue]="transactionFormGroup.valid && buttonEnabled" [inputType]="'submit'">
                            {{ 'FILTER' | translate }}
                        </mapfre-button>
                    </div>
                </div>

            </div>
        </form>
    </ng-container>
    <ng-template #maTransactionFilter>
        <form name="transactionFormGroup" class="margin-top mt32" [formGroup]="transactionFormGroup"
            (ngSubmit)="filterTransactions()">
            <div class="ma-date-container">
                <div class="input-field mapfre filter-input ma-filter-input">
                    <div class="from-container transaction-date-col-ma">
                        <div class="date-label">From</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('fromDate')?.value">
                            <input id="from-date" class="date-input" name="from-date" type="date" placeholder="mm/dd/yyyy" min="2000-01-01"
                                max="2100-12-31" [formControlName]="'fromDate'" (blur)="compareDates()"
                                (keyup)="compareDates()" (change)="compareDates()" mdbInput #fromDate />
                            <img src="assets/img/images/icon-calendar.svg" class="translate-calendar-ma" alt="calendar icon"
                                (click)="openDatePicker('from')" />
                        </div>
                    </div>
   
                    <div class="to-container transaction-date-col-ma">
                        <div class="date-label">To</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('toDate')?.value">
                            <input id="to-date" class="date-input" name="to-date" type="date" placeholder="mm/dd/yyyy" min="2000-01-01"
                                max="2100-12-31" [formControlName]="'toDate'" (blur)="compareDates()"
                                (keyup)="compareDates()" (change)="compareDates()" mdbInput #toDate />
                            <img src="assets/img/images/icon-calendar.svg" class="translate-calendar-ma" alt="calendar icon"
                                (click)="openDatePicker('to')" />
                        </div>
                    
                    </div>
                </div>
                <div class="align-content-end filer-mobile">
                    <mapfre-button [additionalClasses]="'filter-button'" [translateValue]="'FILTER' | translate"
                        [inputType]="'submit'">
                        {{ 'FILTER' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </form>
    </ng-template>

    <div class="billing-mobile-table payment-table transaction-table margin-top mt16">
        <table class="table billing-table table-striped "
            [ngClass]="{' table-striped-acmic transaction-table-acmic':isAcmic,'table-striped-ma':!isAcmic}">
            <tbody>
                <tr class="row-content">
                    <th class="billing-table-col-1">
                        {{ 'Date' | translate }}
                    </th>
                    <th class="billing-table-col-2">
                        {{ 'Description' | translate }}
                    </th>
                    <th class="billing-table-col-3">
                        {{ 'Amount' | translate }}
                    </th>
                    <th class="billing-table-col-4">
                        {{ 'Balance' | translate }}
                    </th>
                </tr>
                <ng-container *ngFor="let transaction of transactions">
                    <tr class="row-content">
                        <td class="billing-table-col-1">
                            {{ transaction?.transactionDate | customDateFormat }}
                        </td>
                        <td class="billing-table-col-2">
                            {{ transaction?.description }}
                        </td>
                        <td class="billing-table-col-3">
                            {{ transaction?.netAmount | currency }}
                        </td>
                        <td class="billing-table-col-4">
                            {{ transaction?.totalBalance | currency }}
                        </td>
                </ng-container>
            </tbody>

            <tfoot *ngIf="showLoadTransaction">
                <tr (click)="loadTransactions()">
                    <td colspan="4" class="transform-trans-txt"
                        [ngClass]="isAcmic ? 'load-more-btn font-bold' : 'mapfre link red-link underlineBQ dm-sans-medium font-weight-500 text-center'">
                        {{ "Load more transactions" }}</td>
                </tr>
            </tfoot>
        </table>
        <!-- <ng-container *ngIf="isAcmic">
            <div class="hide-in-desktop upload-files-in-mobile">
                <ng-container *ngFor="let transaction of transactions">
                    <div class="responsive-upload-card transaction-mobile-table">
                        <div>
                            <p class="table-title">{{ 'Date' | translate }}</p>
                            <p class="table-data">{{ transaction?.transactionDate | customDateFormat }}</p>
                        </div>
                        <div>
                            <p class="table-title">{{ 'Description' | translate }}</p>
                            <p class="table-data">{{ transaction?.description }}</p>
                        </div>
                        <div>
                            <p class="table-title">{{ 'Amount' | translate }}</p>
                            <p class="table-data">{{ transaction?.netAmount | currency }}</p>
                        </div>
                        <div>
                            <p class="table-title">{{ 'Balance' | translate }}</p>
                            <p class="table-data">{{ transaction?.totalBalance | currency }}</p>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showLoadTransaction">
                    <div (click)="loadTransactions()" class="load-more-btn transform-trans-txt">
                        {{ "Load more transactions" | translate }}
                    </div>
                </ng-container>
            </div>
        </ng-container> -->
    </div>
</ng-container>

<h2 class="title dm-sans-medium margin-top mt32" [ngClass]="{ 'dm-sans-medium': !isAcmic }">
    {{ "Didn't find what you were looking for?" }}
</h2>
<div *ngIf="!isAcmic"
    class="dm-sans-medium mapfre link red-link cursor-pointer underlineBQ font-weight-500 margin-top mt16"
    (click)="goToFAQ()">
    {{ "READ_FAQ" | translate }}
</div>
<div [ngClass]="isAcmic ? 'checkout' : 'mapfre link red-link underlineBQ dm-sans-medium font-weight-500 cursor-pointer'"
    class="margin-top mt16" (click)="goToDocuments()">
    {{ "CHECKOUT_MORE" | translate }}
</div>
